import request from '@/utils/request'

let CarouselApi = {
  /*轮播图列表*/
  CarouselList(data, errorback) {
    return request._post('/shop/plus.carousel.carousel/index', data, errorback);
  },
  /*获取轮播图分类*/
  getCategory(data, errorback) {
    return request._post('/shop/plus.carousel.carouselcategory/index', data, errorback);
  },
  /*添加轮播图*/
  toAddCarousel(data, errorback) {
    return request._get('/shop/plus.carousel.carousel/add', data, errorback);
  },
  /*添加轮播图*/
  addCarousel(data, errorback) {
    return request._post('/shop/plus.carousel.carousel/add', data, errorback);
  },
  /*轮播图详情*/
  toEditCarousel(data, errorback) {
    return request._get('/shop/plus.carousel.carousel/edit', data, errorback);
  },
  /*编辑轮播图*/
  editCarousel(data, errorback) {
    return request._post('/shop/plus.carousel.carousel/edit', data, errorback);
  },
  /*删除轮播图*/
  deleteCarousel(data, errorback) {
    return request._post('/shop/plus.carousel.carousel/delete', data, errorback);
  },
  /*添加分类*/
  addCategory(data, errorback) {
    return request._post('/shop/plus.carousel.carouselcategory/add', data, errorback);
  },
  /*编辑分类*/
  editCategory(data, errorback) {
    return request._post('/shop/plus.carousel.carouselcategory/edit', data, errorback);
  },
  /*删除分类*/
  deleteCategory(data, errorback) {
    return request._post('/shop/plus.carousel.carouselcategory/delete', data, errorback);
  },


}
export default CarouselApi;



// WEBPACK FOOTER //
// ./src/api/carousel.js